import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tutorial, TutorialMaterial } from '../../models/tutorial.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-tutorial-item-list',
  templateUrl: './tutorial-item-list.component.html',
  styleUrls: ['./tutorial-item-list.component.scss', './../../tutorial.scss'],
})
export class TutorialItemListComponent extends BaseFormComponent<Tutorial[] | TutorialMaterial[]> implements OnInit {

  selected:boolean = false;
  @Input() isAdmin:boolean = false;
  @Input() isOrdering:boolean = false;
  @Input() type:string = null;
  @Input() data: Tutorial[]|TutorialMaterial[] = null;
  @Output() saveList = new EventEmitter<object>();
  @Output() deleteList = new EventEmitter<number[]>();
  @Output() excluir = new EventEmitter<number>();
  @Output() openModal = new EventEmitter<object>();
  @Output() openItem = new EventEmitter<number>();
  @Output() changeShow = new EventEmitter<{id: number,status: boolean}>();

  constructor(
      public activatedRoute: ActivatedRoute,
            private cdr: ChangeDetectorRef
    ) {
      super(activatedRoute); 
    }
  ngOnInit() {
    this.initForm(this.data);
  }


  initForm(data): void {
    this.data = data;
    this.form = this.createDataFormArray();
    if (this.data) {
      this.form.patchValue(this.data);
    }
  }

  createDataFormArray(): FormGroup{
    if (!this.data) {
      return new FormGroup({
        data: new FormArray([])
      });
    }
    return new FormGroup({
      data:new FormArray(
        this.data.map(item =>{
          return new FormGroup({
            id: new FormControl(item.id, [Validators.required]),
            nro_ord: new FormControl(item.nro_ord ?? 0),
            actived: new FormControl(item.actived ?? false),
            selected: new FormControl(false)
          })
        })
      )
    })
  }

  drop(event): void {
    const previousIndex = this.data?.findIndex(d => d['id'] === event.item.data['id']);
    if (previousIndex !== -1) {
      moveItemInArray( this.data, previousIndex, event.currentIndex);
      const formArray = this.form?.get('data') as FormArray;
      var newList = this.data.map((item, i) => ({...item,'nro_ord':i+1}) );
      console.log(newList)
      this.data.forEach((item, i) => {
        const control = formArray.controls.find(ctrl => ctrl?.get('id')?.value === item['id']);
        control?.get('nro_ord')?.setValue(i+1);
      });
      this.cdr.detectChanges();
      this.form.markAsDirty();
    }
  }

  getDataCreate():object {
    return Object.assign({}, this.form.value);
  }
  
  
  onChangeShow(id: number, status): void{
    var msg = `Você tem que certeza que deseja ${status?'revelar':'ocultar'} este item?`;
    this.alertConfirmation(id,msg).subscribe((confirmed) => {
      if (confirmed) {
        this.changeShow.emit({id,status});
      }
    });
  }
  confirmExcluir(id: number): void {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir.emit(id);
      }
    });
  }
  getIndexForm(item):number {
    var formArray = this.form?.get('data') as FormArray;
    return formArray?.controls?.findIndex(d => d?.get('id').value == (item['id'] ?? 0));
  } 

  sortData(actived:boolean):Tutorial[] | TutorialMaterial[] {
    var filterData = this.data?.filter(d=> d.actived == actived);
    return filterData?.sort(function(a, b) {
      const itemA = this.getFormItem(a);
      const itemB = this.getFormItem(b);
      return itemA?.value?.nro_ord - itemB?.value?.nro_ord;
    }.bind(this)); 

  }
  onChangeOrder(): void{
    var newData = this.getDataCreate();
    this.saveList.emit(newData);
    this.isOrdering = false;
  }
  onOpenModal(id = null): void{
    this.openModal.emit(id);
  }
  onOpenItem(id = null): void{
    this.openItem.emit(id);
  }
  onSalvar(): void{
    if (this.form.valid) {
      var newData = this.getDataCreate();
      this.openModal.emit(newData);
    }
    else {
      this.markAsDirty();
    }
  }
  selectAll(event){
    event.stopPropagation();
    const isChecked = (event.target as HTMLInputElement).checked;
    const dataArray = this.form.get('data') as FormArray;
    dataArray.controls.forEach(control => {
      control.get('selected')?.setValue(isChecked);
    })
    this.selected = isChecked;

  }
  selectItem(){
    const dataArray = this.form.get('data') as FormArray;
    var result = dataArray.controls.some(control => control.get('selected').value == true);
    this.selected = result;
    console.log(dataArray)
  }
  allSelected(){
    const dataArray = this.form.get('data') as FormArray;
    var result = dataArray.controls.every(control => control.get('selected').value == true);
    return result;
  }

  getFormItem(item):AbstractControl {
    var formArray = this.form?.get('data') as FormArray;
    return formArray?.controls.find(d => d.get('id').value == (item['id'] ?? 0));
  } 
  changeItems(status):void{
    this.alertConfirmation(status,'Tem certeza que deseja mudar o status destes itens?').subscribe((confirmed) => {
      if (confirmed) {
        const dataArray = this.form.get('data') as FormArray;
        var filterData = dataArray.controls.filter(control => control.get('selected').value == true);
        filterData.forEach(control => {
          control.get('actived')?.setValue(status);
        });
        this.saveList.emit(this.getDataCreate());
      }
    });
  }
  deleteItems(){
    this.alertConfirmation(status,'Ter certeza que deseja deletar esses itens?').subscribe((confirmed) => {
      if (confirmed) {
        const dataArray = this.form.get('data') as FormArray;
        var filterData = dataArray.controls.filter(control => control.get('selected').value == true);
        var ids = filterData.map(control => control.get('id')?.value);
        this.deleteList.emit(ids);
      }
    });
  }
  anyDisable():boolean{
    var filterData = this.data?.some(d=> d.actived == false);
    return filterData
  }
}
